import { StyleRules } from '@mui/styles';
import { COLORS } from '../../../../../../constants';

const styles = (): StyleRules => ({
    root: {
        width: 'auto',
        flexGrow: 1,
    },
    notesGridItem: {
        padding: '2px',
        width: '100%',
    },
    paperNotes: {
        boxShadow: 'none',
        border: `1px solid ${COLORS.GRAY_LIGHT}`,
        backgroundColor: '#fff',
        alignItems: 'stretch',
        padding: '0px',
        display: 'flex',
        justify: 'flex-start',
        flexDirection: 'column',
        position: 'relative',
    },
    notesTextField: {
        padding: '24px',
        minHeight: '195px',
        fontSize: '16px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.75,
        letterSpacing: '0.5px',
        color: '#54565a',
        alignItems: 'flex-start',
    },
    narrative: {
        border: 'none',
    },
    saving: {
        position: 'absolute',
        bottom: '1px',
        right: '7px',
    },
});

export default styles;
